import type { Dispatch, SetStateAction } from "react";
import NotificationAlertOptions from "@/layouts/Alerts";
import { clearMessage } from "@/services/clientService/clientActions";

// The Add and Update client screens share one form shape and the same two
// handlers; they live here so a fix lands on both (SCRUM-2279).
export type ClientForm = {
  name: string;
  about: string;
  contacts: { email: string; number: string; website: string };
  social_links: { facebook: string; linkedin: string; twitter: string };
  adresse: string;
  country_code: string;
  legal_name: string;
};

export type ClientValidation = { name: boolean; country_code: boolean };

export const emptyClient = (): ClientForm => ({
  name: "",
  about: "",
  contacts: { email: "", number: "", website: "" },
  social_links: { facebook: "", linkedin: "", twitter: "" },
  adresse: "",
  country_code: "",
  legal_name: "",
});

export const makeClientOnChange =
  (
    setClient: Dispatch<SetStateAction<ClientForm>>,
    setValidation: Dispatch<SetStateAction<ClientValidation>>,
  ) =>
  (e: { target: { name: string; value: string } }) => {
    const { name, value } = e.target;

    if (["facebook", "linkedin", "twitter"].includes(name)) {
      setClient((prev) => ({
        ...prev,
        social_links: { ...prev.social_links, [name]: value },
      }));
      return;
    }

    if (["website", "email", "number"].includes(name)) {
      setClient((prev) => ({
        ...prev,
        contacts: { ...prev.contacts, [name]: value },
      }));
      return;
    }

    setClient((prev) => ({ ...prev, [name]: value }));
    setValidation((v) => ({ ...v, [name]: true }));
  };

// After a save the slice carries a success message: toast it, clear it, and
// reset the form.
export const showClientMessage = (
  message: string | undefined,
  dispatch: (action: ReturnType<typeof clearMessage>) => unknown,
  setLoading: Dispatch<SetStateAction<boolean>>,
  setClient: Dispatch<SetStateAction<ClientForm>>,
) => {
  if (message && message !== "") {
    NotificationAlertOptions("success", message);
    dispatch(clearMessage());
    setLoading(false);
    setClient(emptyClient());
  }
};
